module.exports = __webpack_public_path__ + "img/logo-sm-dark.888bd3c7.png";